
export class User
{
    private codeclient : string;
    private username : string;
    private password : string;


public constructor (user : any){
    this.codeclient = user.codeclient;
    this.username = user.login;
    this.password = user.password;

}

public get_codeclient(): string {
    return this.codeclient;
}
public get_username(): string {
    return this.username;
}
public get_password(): string {
    return this.password;
}


}

